import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { REDESIGN_COLORS } from '../../styles/colors';
import { getOverallTag } from '../../utils/scoreTags';

/**
 * OverallMatchBadge — descriptive tier label (e.g. "Strong match") that
 * replaces the numeric ScoreBadge. Cohort/availability signals (Top match,
 * Best deal, Just listed, Price drop) live on the FeedListingCard image
 * overlay, not next to the tier badge.
 *
 * @param {Object} props
 * @param {Object} props.listing          - Feed entry (score, listing_snapshot)
 * @param {boolean} [props.isExternalUrl] - If true and score=0, render "Score pending" placeholder
 */
const OverallMatchBadge = ({ listing, isExternalUrl = false }) => {
  const score = listing && listing.score != null ? Number(listing.score) : 0;

  // External URL listings still resolving enrichment: keep parity with old badge.
  if (isExternalUrl && score === 0) {
    return (
      <View style={[styles.badgeBase, styles.pendingBadge]}>
        <Text style={styles.pendingText}>SCORE PENDING</Text>
      </View>
    );
  }

  const { tier } = getOverallTag(listing);
  const tierStyle = TIER_STYLES[tier.key] || TIER_STYLES.solid;

  return (
    <View style={[styles.badgeBase, { backgroundColor: tierStyle.bg }]}>
      <Text style={[styles.tierText, { color: tierStyle.text }]}>{tier.label}</Text>
    </View>
  );
};

const TIER_STYLES = {
  strong: { bg: REDESIGN_COLORS.scoreGoodBg,   text: REDESIGN_COLORS.scoreGood   },
  solid:  { bg: 'rgba(255,255,255,0.10)',      text: 'rgba(255,255,255,0.95)'    },
  mixed:  { bg: REDESIGN_COLORS.scoreMediumBg, text: REDESIGN_COLORS.scoreMedium },
  limited:{ bg: REDESIGN_COLORS.scorePoorBg,   text: REDESIGN_COLORS.scorePoor   },
};

const styles = StyleSheet.create({
  badgeBase: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    alignSelf: 'flex-start',
    borderRadius: 16,
  },
  tierText: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 12,
    letterSpacing: 0.24,
    textTransform: 'uppercase',
  },
  pendingBadge: {
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  pendingText: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 12,
    letterSpacing: 0.24,
    color: 'rgba(255,255,255,0.5)',
    textTransform: 'uppercase',
  },
});

export default OverallMatchBadge;
